export const statusesInclude = (statuses, state) =>
  statuses.includes(typeof state !== "string" ? Object.entries(state)[0][1] : state);
